import { supabase } from '@/lib/supabase';

export interface AdminProfile {
  id: string;
  email: string | null;
  full_name: string | null;
  avatar_url: string | null;
  role: string;
  verified: boolean;
  phone: string | null;
  city: string | null;
  created_at: string;
}

export async function fetchAllProfiles(): Promise<AdminProfile[]> {
  const { data, error } = await supabase
    .from('profiles')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) throw error;
  return (data as AdminProfile[]) || [];
}

export async function setUserVerified(id: string, verified: boolean): Promise<void> {
  const { error } = await supabase
    .from('profiles')
    .update({ verified })
    .eq('id', id);
  if (error) throw error;
}

export interface AdminProfileUpdate {
  full_name?: string | null;
  city?: string | null;
  phone?: string | null;
  role?: string;
}

export async function updateUserProfile(id: string, fields: AdminProfileUpdate): Promise<void> {
  const { error } = await supabase.from('profiles').update(fields).eq('id', id);
  if (error) throw error;
}

export async function deleteUser(id: string): Promise<void> {
  const { error } = await supabase.from('profiles').delete().eq('id', id);
  if (error) throw error;
}